import api from './api';

const eventService = {
  // Create new event
  createEvent: async (eventData) => {
    const formData = new FormData();

    // Append all event fields
    Object.keys(eventData).forEach(key => {
      if (key === 'banner' && eventData[key]) {
        // Append file
        formData.append('banner', eventData[key]);
      } else if (key === 'brochure' && eventData[key]) {
        // Append file
        formData.append('brochure', eventData[key]);
      } else if (key === 'dates' || key === 'location' || key === 'tags' || key === 'customFields') {
        // Stringify objects/arrays
        formData.append(key, JSON.stringify(eventData[key]));
      } else if (eventData[key] !== undefined && eventData[key] !== null) {
        formData.append(key, eventData[key]);
      }
    });

    const response = await api.post('/events', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Get all events with filters
  getEvents: async (params = {}) => {
    const response = await api.get('/events', { params });
    return response.data;
  },

  // Get single event by ID
  getEventById: async (id) => {
    const response = await api.get(`/events/${id}`);
    return response.data;
  },

  // Get event by slug
  getEventBySlug: async (slug) => {
    const response = await api.get(`/events/slug/${slug}`);
    return response.data;
  },

  // Update event
  updateEvent: async (id, eventData) => {
    const formData = new FormData();

    Object.keys(eventData).forEach(key => {
      if (key === 'banner' && eventData[key] && typeof eventData[key] !== 'string') {
        formData.append('banner', eventData[key]);
      } else if (key === 'brochure' && eventData[key] && typeof eventData[key] !== 'string') {
        formData.append('brochure', eventData[key]);
      } else if (key === 'dates' || key === 'location' || key === 'tags' || key === 'customFields') {
        formData.append(key, JSON.stringify(eventData[key]));
      } else if (eventData[key] !== undefined && eventData[key] !== null) {
        formData.append(key, eventData[key]);
      }
    });

    const response = await api.put(`/events/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Delete event
  deleteEvent: async (id) => {
    const response = await api.delete(`/events/${id}`);
    return response.data;
  },

  // Get event statistics
  getEventStats: async (id) => {
    const response = await api.get(`/events/${id}/stats`);
    return response.data;
  },

  // Get dashboard statistics
  getDashboardStats: async () => {
    const response = await api.get('/events/stats/dashboard');
    return response.data;
  },

  // Helper to get image URL
  getImageUrl: (relativePath) => {
    if (!relativePath) return null;
    if (relativePath.startsWith('http')) return relativePath;
    return `${process.env.REACT_APP_API_URL.replace('/api/v1', '')}${relativePath}`;
  }
};

export default eventService;
